import { render, staticRenderFns } from "./AssetIssuanceDetailsView.vue?vue&type=template&id=28fbfbd0"
import script from "./AssetIssuanceDetailsView.vue?vue&type=script&lang=js"
export * from "./AssetIssuanceDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports